var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 290,
    viewBox: "0 0 290 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.844,
    cy: 145.766,
    r: 42.639,
    fill: "#F2FCF9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.853,
    cy: 144.774,
    r: 59.4963,
    transform: "rotate(180 143.853 144.774)",
    stroke: "#A9EED8",
    strokeWidth: 0.905434
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.347,
    cy: 145.27,
    r: 76.8494,
    stroke: "#A9EED8",
    strokeWidth: 0.905434,
    strokeDasharray: 3.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 290C225.081 290 290 225.081 290 145C290 64.9187 225.081 0 145 0C64.9187 0 0 64.9187 0 145C0 225.081 64.9187 290 145 290ZM145 260.372C208.718 260.372 260.372 208.718 260.372 145C260.372 81.2821 208.718 29.6285 145 29.6285C81.2821 29.6285 29.6285 81.2821 29.6285 145C29.6285 208.718 81.2821 260.372 145 260.372Z",
    fill: "#F2FCF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.644 144.774C168.644 157.918 157.989 168.573 144.845 168.573C131.702 168.573 121.047 157.918 121.047 144.774C121.047 131.631 131.702 120.976 144.845 120.976C157.989 120.976 168.644 131.631 168.644 144.774ZM125.013 144.774C125.013 155.727 133.892 164.606 144.845 164.606C155.798 164.606 164.677 155.727 164.677 144.774C164.677 133.821 155.798 124.942 144.845 124.942C133.892 124.942 125.013 133.821 125.013 144.774Z",
    fill: "#1AD598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.593 149.994L135.722 144.435C135.136 143.767 134.13 143.71 133.475 144.308C132.821 144.906 132.765 145.933 133.351 146.601L139.302 153.392C139.895 154.069 140.917 154.118 141.569 153.5L157.028 138.863C157.672 138.253 157.71 137.226 157.113 136.568C156.515 135.91 155.509 135.872 154.865 136.482L140.593 149.994Z",
    fill: "#A9EED8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a46829708529417f2850d2d63a629db8.svg";
export { ForwardRef as ReactComponent };